/* ============================= E X P O R T ============================= */

export default {
  name: 'Times',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary',
        'red',
        'green',
        'blue',
        'yellow-bold'
      ]
    }
  }
}
